import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '../../util/log.service';
import { API_ENDPOINTS, ApiService } from '../api.service';
import { GenericApiClientService } from '../generic-api-client.service';
import { IApiQueryOptions } from '../models/api-query-params.model';
import { IEntryCodeModel } from './entry-code-model.interface';
import { EntryCodeTransformService } from './entry-code-transform.service';

@Injectable({
  providedIn: 'root'
})
export class EntryCodeClientService extends GenericApiClientService<IEntryCodeModel> {
  constructor(http: HttpClient, apiService: ApiService, log: LogService, transformer: EntryCodeTransformService) {
    super(http, apiService, log, transformer);
    this.itemsUrl = apiService.getUrlFor(API_ENDPOINTS.entryCodes);
    this.singleItemUrl = apiService.getUrlFor(API_ENDPOINTS.entryCode);
  }

  /**
   * Get entry codes for a specific flat
   * @param flatId The flat ID to get entry codes for
   * @param options Query options for filtering, ordering, and pagination
   * @returns Observable of paginated entry codes
   */
  private getFlatEntryCodes(flatId: number, options?: IApiQueryOptions): Observable<IEntryCodeModel[]> {
    const url = this.apiService.getUrlFor(API_ENDPOINTS.flats) + '/' + flatId + '/entry_codes';
    return this.getAllItems(url, options);
  }

  /**
   * Get active entry codes for a flat and optionally filtered by user ID
   * Uses the modern approach with query params instead of client-side filtering
   *
   * @param flatId The flat ID to get entry codes for
   * @param userId Optional user ID to filter by
   * @returns Observable of active entry codes
   */
  getActiveEntryCodes(flatId: number, userId?: number): Observable<IEntryCodeModel[]> {
    return this.getFlatEntryCodes(flatId, this.activeCodeOptions());
  }

  /**
   * Minden lakás még érvényes kódja (valid_to a mai nap után) egy lapozott lekérésben —
   * a lakásonkénti getActiveEntryCodes összevont párja, ugyanazzal a szűrővel.
   */
  getActiveEntryCodesForAllFlats(): Observable<IEntryCodeModel[]> {
    return this.getAllItems('', this.activeCodeOptions());
  }

  /** Active entry codes: valid_to must be after the current date. */
  private activeCodeOptions(): IApiQueryOptions {
    return {
      dateFilters: {
        valid_to: {
          date: new Date(),
          operator: 'after'
        }
      }
    };
  }
}
